export const getPetitVerdotFranceData = () => ({
  name: "Petit Verdot",
  country: "France",
  description: "Le Petit Verdot est principalement cultivé dans le Bordelais, où il est utilisé en assemblage pour apporter structure.",
  regions: [
    { name: "Médoc", area: "1,200 ha", percentage: "45%", description: "Cépage d'assemblage" },
    { name: "Graves", area: "800 ha", percentage: "30%", description: "Usage limité" },
    { name: "Saint-Émilion", area: "400 ha", percentage: "15%", description: "Assemblage" },
    { name: "Pomerol", area: "200 ha", percentage: "7%", description: "Usage très limité" },
    { name: "Autres", area: "100 ha", percentage: "3%", description: "Dispersé dans le Bordelais" }
  ],
  mapAreas: [
    { region: "Médoc", x: 25, y: 70, color: "#4B164C", size: 4 },
    { region: "Graves", x: 30, y: 75, color: "#6d2c7a", size: 3 },
    { region: "Saint-Émilion", x: 35, y: 72, color: "#8a4a8a", size: 2 },
    { region: "Pomerol", x: 33, y: 73, color: "#a768a6", size: 1 }
  ],
  subregions: {
    bordeaux: {
      name: "Bordeaux",
      description: "Le Petit Verdot est un cépage d'assemblage bordelais, apportant structure et complexité aux vins.",
      characteristics: {
        aromas: "Fruits noirs, violette, épices, notes herbacées",
        body: "Corps plein et puissant",
        tannins: "Tannins très fermes et structurés",
        aging: "Excellent potentiel (15-25 ans)"
      },
      terroir: {
        climate: "Climat océanique tempéré",
        soil: "Graves et argiles",
        viticulture: "Rendements très limités, vendanges tardives"
      },
      differentiators: [
        "Structure tannique exceptionnelle",
        "Notes de violette caractéristiques",
        "Complexité aromatique unique",
        "Cépage d'assemblage de prestige"
      ],
      foodPairing: "Viandes rouges très riches, gibier, fromages forts"
    }
  }
}); 